import { render, staticRenderFns } from "./newsxiangqing1.vue?vue&type=template&id=2df59cca&scoped=true&"
import script from "./newsxiangqing1.vue?vue&type=script&lang=js&"
export * from "./newsxiangqing1.vue?vue&type=script&lang=js&"
import style0 from "./newsxiangqing1.vue?vue&type=style&index=0&id=2df59cca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df59cca",
  null
  
)

export default component.exports